import * as Switch from '@radix-ui/react-switch';
import { styled } from 'styled-components';

export const SwitchInput = ({
  label,
  id,
  value,
  onChange,

  nocolor,
}: {
  label?: string;
  id: string;
  value: boolean;
  onChange: (value: boolean) => void;

  nocolor?: boolean;
}) => (
  <Container $nocolor={nocolor}>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {label && (
        <label className="LabelRoot" htmlFor={id}>
          {label}
        </label>
      )}
      <Switch.Root
        className="SwitchRoot"
        id={id}
        checked={value}
        onCheckedChange={(checked: any) => onChange(checked)}
      >
        <Switch.Thumb className="SwitchThumb" />
      </Switch.Root>
    </div>
  </Container>
);

const Container = styled.div<{ $nocolor?: boolean }>`
  .SwitchRoot {
    width: 42px;
    height: 20px;
    display: flex;
    align-items: center;
    background-color: var(--panel-bg-color);
    border-radius: 9999px;
    position: relative;
    -webkit-tap-highlight-color: #000;

    transition: background-color 1s ease;
  }
  .SwitchRoot:hover {
    background-color: var(--panel-bg-color-hover);
  }
  .SwitchRoot[data-state='checked'] {
    ${({ $nocolor }) => !$nocolor && `background-color: var(--accent-color);`}
  }

  .SwitchThumb {
    display: block;
    width: 18px;
    height: 18px;
    background-color: var(--text-color-secondary);
    border-radius: 9999px;
    transform: translateX(2px);
    will-change: transform;

    transition:
      transform 100ms,
      background-color 1s ease;
  }
  .SwitchThumb[data-state='checked'] {
    background-color: var(--text-color);
    transform: translateX(23px);
  }

  .LabelRoot {
    font-size: 11px;
    font-weight: 400;
    color: var(--text-color-secondary);
    padding-right: 5px;

    white-space: nowrap;
  }
`;
